import { IonButton, IonButtons, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonList, IonNote, IonSpinner, IonTitle, IonToolbar } from "@ionic/react";
import { t } from "i18next";
import React, { useContext, useState } from "react";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import { ApiService } from "../../services";

export const ChangePasswordModal = (props: any) => {
  const [current, setCurrent] = useState<any>("");
  const [newPassword, setNewPassword] = useState<any>("");
  const [verify, setVerify] = useState<any>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const { member } = useContext(AuthenticatedUserContext);

  const confirm = () => {
    setIsLoading(true);

    ApiService.post("members/" + member!.id + "/account/change-password", {
      current: current,
      new: newPassword,
      new_confirmation: verify,
    })
      .then(() => {
        setIsLoading(false);
        setErrors({});
        props.onSuccess();
      })
      .catch((response) => {
        setIsLoading(false);
        setErrors(response.errors);
      });
  };

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => props.onDismiss()}>{t("cancel")}</IonButton>
          </IonButtons>
          <IonTitle>{t("changePassword")}</IonTitle>
          <IonButtons slot="end">
            {isLoading ? (
              <IonSpinner name={"dots"} />
            ) : (
              <IonButton strong={true} onClick={confirm} disabled={!current || !newPassword || !verify}>
                {t("change")}
              </IonButton>
            )}
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonList inset={true}>
          <IonItem className={errors.current ? "ion-invalid" : ""}>
            <IonLabel>{t("current")}</IonLabel>
            <IonInput disabled={isLoading} onIonChange={(e) => setCurrent(e.target.value)} placeholder={t("currentPassword") || ""} type={"password"}></IonInput>
            {errors.current && <IonNote slot={"error"}>{errors.current?.map((er: string, index: number) => <div key={"current-" + index}>{er}</div>)}</IonNote>}
          </IonItem>

          <IonItem className={errors.new ? "ion-invalid" : ""}>
            <IonLabel>{t("new")}</IonLabel>
            <IonInput disabled={isLoading} onIonChange={(e) => setNewPassword(e.target.value)} placeholder={t("enterPassword") || ""} type={"password"}></IonInput>
            {errors.new && <IonNote slot={"error"}>{errors.new?.map((er: string, index: number) => <div key={"new-" + index}>{er}</div>)}</IonNote>}
          </IonItem>

          <IonItem className={errors.new_confirmation ? "ion-invalid" : ""}>
            <IonLabel>{t("verify")}</IonLabel>
            <IonInput disabled={isLoading} onIonChange={(e) => setVerify(e.target.value)} placeholder={t("reenterPassword") || ""} type={"password"}></IonInput>
            {errors.new_confirmation && <IonNote slot={"error"}>{errors.new_confirmation?.map((er: string, index: number) => <div key={"new_confirmation-" + index}>{er}</div>)}</IonNote>}
          </IonItem>
        </IonList>

        <div>
          <IonNote>{t("passwordRequirements")}</IonNote>
        </div>

        <div className={"ion-margin-top"}>
          <IonNote>{t("changePasswordNote")}</IonNote>
        </div>
      </IonContent>
    </>
  );
};
